import React from "react";
import { motion } from "framer-motion";

const CustomCSS = () => {
  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Custom CSS
      </motion.h5>

      {/* INNER CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="card-body">

          <label className="form-label fw-semibold mb-2">
            Write Custom CSS
          </label>

          {/* CODE BLOCK (Bootstrap only) */}
          <motion.div
            className="bg-dark text-white p-3 rounded overflow-auto"
            style={{ minHeight: "200px" }}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25 }}
            whileHover={{ scale: 1.01 }}
          >
            <pre className="mb-0 small font-monospace text-white">
{`.section-header {
  margin-bottom: 60px;
}

.section-header h2 {
  font-size: 36px;
  font-weight: 700;
  color: #0A0A0A;
  margin-bottom: 14px;
}`}
            </pre>
          </motion.div>

        </div>
      </motion.div>
    </motion.div>
  );
};

export default CustomCSS;